export default [
  {
    path: "auditoria",
    name: "audit-list",
    component: () => import("@/modules/audits/views/AuditsList.vue"),
    meta: {
      requiresAuth: true,
      roles: ["superadmin","admin"],
    },
    /*children: [
      {
        path: ":id",
        name: "mail-maintainer-show",
        component: () => import("@/modules/mail-maintainer/views/MailShow.vue"),
      },
    ],*/
  },
];
